import middleware from './middleware'

class ExperimentMiddleware {
  constructor({ $experiment }) {
    this.$experiment = $experiment
  }

  handle() {
    this.$experiment.init()
  }
}

middleware.experiment = ({ app: { $experiment } }) => {
  const experimentMiddleware = new ExperimentMiddleware({ $experiment })
  experimentMiddleware.handle()
}
